export default { sha: '85b3baa9679ba21e4dacae73ecaef44b96dfee60', buildNumber: 'undefined' }
